<template>
  <div
    class="h-full p-6 rounded-lg  flex flex-col relative overflow-hidden font-display"
    :class="isPopular"
  >
    <span
    v-if="discount"
      class="bg-indigo-500 text-white px-3 py-1 text-sm absolute right-0 top-0 rounded-bl"
      >{{ `${discount}%` }} de desconto</span
    >
    <h2 class="text-sm tracking-widest title-font mb-1 font-medium">
      {{ title }}
    </h2>
    <h1 class="text-4xl text-gray-900 leading-none flex items-center font-bold">
      <span>{{ (price - (price / 100) * discount) | toCurrency }}</span>
      <span class="text-lg ml-1 font-normal text-gray-500">/mês</span>
    </h1>
    <small
      class="mt-4 pb-4 mb-4  border-b border-gray-200 text-gray-500 "
      v-if="total > 0"
      >cobrado o valor total de
      {{ (price - (price / 100) * discount) | toCurrency }} a cada
      {{ recorrence }} meses.</small
    >
    <small
      class="mt-4 pb-4 mb-4  border-b border-gray-200 text-gray-500 "
      v-else
      >Sem custo.</small
    >

    <p class="flex items-center text-gray-600 mb-2">
      <span
        class="w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0"
      >
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          class="w-3 h-3"
          viewBox="0 0 24 24"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg> </span
      >Catalogo Digital
    </p>
    <p class="flex items-center text-gray-600 mb-2">
      <span
        class="w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0"
      >
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          class="w-3 h-3"
          viewBox="0 0 24 24"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg> </span
      >Sem limite de Produtos
    </p>
    <router-link
      v-if="!popular"
      :to="{ name: 'subscription.checkout', params: { plan: plan_id } }"
      :class="
        !popular
          ? 'bg-indigo-500 hover:bg-indigo-600'
          : 'bg-gray-500 hover:bg-gray-600'
      "
      class="flex items-center mt-auto text-white  border-0 py-2 px-4 w-full focus:outline-none  rounded"
      exact
    >
      Assinar
      <svg
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        class="w-4 h-4 ml-auto"
        viewBox="0 0 24 24"
      >
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    price: {
      type: Number,
      default: 29.9
    },
    discount: {
      type: Number,
      default: 0
    },
    popular: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Mensal'
    },
    plan_id: {
      type: String,
      default: 'mensal'
    },
    recorrence: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isPopular() {
      if (!this.popular) {
        return ['border-2', 'border-indigo-500']
      }
      return ['border-2', 'border-gray-300']
    },
    total() {
      return this.price * this.recorrence
    }
  },
  methods: {}
}
</script>

<style></style>
